// Apolo IDE — runtime detection helper.
// Returns true when the renderer is running inside the Electron .app, false in
// the web/Pages build. Used to gate Electron-only UI (file dialogs, IPC seams).
export function isElectron() {
  if (typeof window === 'undefined') return false;
  if (typeof navigator !== 'undefined' && /Electron/i.test(navigator.userAgent || '')) return true;
  if (typeof window.process?.versions?.electron === 'string') return true;
  // Last-resort signal: preload contextBridge exposed window.apolo. The web
  // build has no preload so window.apolo is undefined.
  return Boolean(window.apolo && typeof window.apolo === 'object');
}
